import { createPreviewFileFromGlbFile } from "./plan_preview_renderer"

const FILE_PICKER_ICON = `
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M14 3.75H7.75A2.75 2.75 0 0 0 5 6.5v11A2.75 2.75 0 0 0 7.75 20.25h8.5A2.75 2.75 0 0 0 19 17.5V8.75L14 3.75Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
    <path d="M14 3.75V8h4.25" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
  </svg>
`

const filePickerText = (input) => {
  const files = Array.from(input.files || [])

  if (files.length === 0) {
    return input.multiple ? "No files selected" : "No file selected"
  }

  if (files.length === 1) return files[0].name

  return `${files.length} files selected`
}

const syncFilePicker = (input) => {
  const picker = input.closest("[data-plan-file-picker]")
  const text = picker?.querySelector("[data-plan-file-picker-text]")

  if (!picker || !text) return

  const hasValue = (input.files?.length || 0) > 0
  picker.classList.toggle("has-value", hasValue)
  text.textContent = filePickerText(input)
}

const mountPlanFilePickers = () => {
  document.querySelectorAll(".plan-file-form input[type='file']").forEach((input) => {
    if (input.dataset.planFilePickerMounted === "true") {
      syncFilePicker(input)
      return
    }

    input.dataset.planFilePickerMounted = "true"
    input.classList.add("plan-file-input-native")

    const picker = document.createElement("label")
    picker.className = "plan-file-picker"
    picker.dataset.planFilePicker = "true"

    const text = document.createElement("span")
    text.className = "plan-file-picker-text"
    text.dataset.planFilePickerText = "true"

    const trigger = document.createElement("span")
    trigger.className = "plan-file-picker-trigger"
    trigger.innerHTML = FILE_PICKER_ICON

    input.parentNode.insertBefore(picker, input)
    picker.appendChild(input)
    picker.appendChild(text)
    picker.appendChild(trigger)

    input.addEventListener("change", () => {
      syncFilePicker(input)
    })

    syncFilePicker(input)
  })
}

export const mountPlanPreviewGenerator = () => {
  mountPlanFilePickers()

  document.querySelectorAll("[data-plan-preview-form]").forEach((form) => {
    if (form.dataset.planPreviewMounted === "true") return
    form.dataset.planPreviewMounted = "true"

    const modelInput = form.querySelector("[data-plan-preview-model-input]")
    const previewInput = form.querySelector("[data-plan-preview-image-input]")
    const previewImage = form.querySelector("[data-plan-preview-image]")
    const previewPlaceholder = form.querySelector("[data-plan-preview-placeholder]")
    const status = form.querySelector("[data-plan-preview-status]")
    const submitButton = form.querySelector('input[type="submit"], button[type="submit"]')

    if (!modelInput || !previewInput || !previewImage || !previewPlaceholder || !status) return

    const state = { generating: false }

    const setStatus = (message) => {
      status.textContent = message
    }

    const setSubmittingState = (generating) => {
      if (!submitButton) return

      submitButton.disabled = generating
      submitButton.value = generating ? "Generating Preview..." : "Save 3D Assets"
      if ("textContent" in submitButton && submitButton.tagName === "BUTTON") {
        submitButton.textContent = generating ? "Generating Preview..." : "Save 3D Assets"
      }
    }

    const attachPreviewFile = async () => {
      const file = modelInput.files?.[0]
      if (!file) return

      state.generating = true
      setSubmittingState(true)
      setStatus("Generating preview image...")

      try {
        const previewFile = await createPreviewFileFromGlbFile(file)
        const dataTransfer = new DataTransfer()
        dataTransfer.items.add(previewFile)
        previewInput.files = dataTransfer.files
        previewInput.dispatchEvent(new Event("change", { bubbles: true }))

        const objectUrl = URL.createObjectURL(previewFile)
        previewImage.src = objectUrl
        previewImage.hidden = false
        previewPlaceholder.hidden = true
        setStatus("Preview image generated.")
      } catch (error) {
        const dataTransfer = new DataTransfer()
        previewInput.files = dataTransfer.files
        previewInput.dispatchEvent(new Event("change", { bubbles: true }))
        previewImage.hidden = true
        previewPlaceholder.hidden = false
        setStatus(`Preview generation failed. ${error?.message || "The plan can still be saved."}`)
      } finally {
        state.generating = false
        setSubmittingState(false)
      }
    }

    modelInput.addEventListener("change", () => {
      attachPreviewFile()
    })

    form.addEventListener("submit", async (event) => {
      if (!state.generating) return

      event.preventDefault()
      const waiter = window.setInterval(() => {
        if (state.generating) return

        window.clearInterval(waiter)
        form.requestSubmit()
      }, 120)
    })
  })
}
